import {
  DXR,
  RichEdit,
  SubDocumentBase,
} from '../../../common/devexpress/RichEdit/dx-richedit';

function isPositionInsideDocVariable(
  subdoc: SubDocumentBase,
  position: number,
) {
  const field = subdoc.fields.find(position);
  return field.length > 0;
}

export function convertFields(sender: RichEdit | undefined) {
  if (!sender) {
    return;
  }

  try {
    sender.loadingPanel.show();

    const regex = new RegExp('{(DOCVARIABLE )?([XF]\\d+)}', 'g');
    sender.history.beginTransaction();

    sender.document.subDocuments.forEach((subDocument) => {
      const text = subDocument.getText({
        start: 0,
        length: subDocument.length,
      });
      const matches = text.matchAll(regex);
      let startDiff = 0;
      for (const match of matches) {
        const start = match.index! + startDiff;
        if (isPositionInsideDocVariable(subDocument, start)) {
          continue;
        }

        subDocument.deleteText(new DXR.Interval(start, match[0].length));
        const mergeFieldCode = match[2];

        subDocument.fields.create(start, 'DOCVARIABLE ' + mergeFieldCode);

        startDiff += 13 - (match[1] ?? '').length;
      }
    });
  } finally {
    sender.history.endTransaction();
    sender.loadingPanel.hide();
  }
}
